/**
 * The support team's console lives on its own host (console.callizy.ca), served
 * by the same bundle as app.callizy.ca. On that host only the console mounts:
 * no client pages, no analytics, no session replay, and its own session,
 * separate from any client session.
 *
 * The host name lives here once. Locally, run Vite with
 * VITE_HOTE_CONSOLE=console.localhost and open http://console.localhost:5173.
 */
export const CONSOLE_HOST: string = String(import.meta.env.VITE_HOTE_CONSOLE || 'console.callizy.ca').toLowerCase()

export function isConsoleHost(host: string = window.location.hostname): boolean {
  return (host || '').toLowerCase() === CONSOLE_HOST
}
